import React, {useEffect, useState} from "react";
import AutoFormCard from "../../../components/common/AutoFormCard";
import {useNavigate, useSearchParams} from "react-router-dom";
import {ApiService} from "../../../services/ApiService";
import {message} from "antd";
import {FormUtils} from "../../../utils/FormUtils";
import {ValueUtils} from "../../../utils/ValueUtils";

const FORM = [
    {
        name: "姓名",
        key: "name",
        type: "input",
        required: true,
    },
    {
        name: "性别",
        key: "gender",
        type: "gender",
        required: true,
    },

    {
        name: "生日",
        key: "birthday",
        type: "date",
        required: true,
    },
    {
        name: "工作单位",
        key: "workUnit",
        type: "input",
        required: true,
    },
    {
        name: "职务",
        key: "jobTitle",
        type: "input",
        required: true,
    },
    {
        name: "教育背景",
        key: "educationBackgroundId",
        type: "select",
        required: true,
    },
    {
        type: 'div',
    },
    {
        name: "身份证号",
        key: "idNumber",
        type: "input",
    },
    {
        name: "毕业院校",
        key: "school",
        type: "input",
    },
    {
        name: "主修专业",
        key: "major",
        type: "input",
    },
    {
        name: "职务级别",
        key: "jobTitleLevel",
        type: "input",
    },
    {
        name: "政治安排",
        key: "politicalWork",
        type: "input",
    },
    {
        name: "所在位置",
        key: "coordinates",
        type: "input",
    },
    {
        name: "籍贯",
        key: "nativePlace",
        type: "text",
        maxLength: 100,
    },
]

const NonalignedEditPage = () => {
    const [searchParams] = useSearchParams()
    const navigator = useNavigate()

    const guid = searchParams.get("guid")

    const [initFormData, setInitFormData] = useState({})
    const [educationBackgrounds, setEducationBackgrounds] = useState([])

    let changedForms = {}

    useEffect(() => {
        if (guid) {
            ApiService.admin.partyWork.nonalignedRepresentative.get(guid)
                .onSuccess(data => {
                    setInitFormData({
                        ...data,
                        birthday: ValueUtils.getMomentOrNull(data.birthday)
                    })
                })
        }

        ApiService.constants.educationBackgrounds()
            .onSuccess(setEducationBackgrounds)
    }, [guid]);

    const handleFormChange = (change) => {
        changedForms = {
            ...changedForms,
            ...change
        }
    }

    const createOrUpdate = (form) => {
        if (guid) {
            return ApiService.admin.partyWork.nonalignedRepresentative.update(form)
        } else {
            return ApiService.admin.partyWork.nonalignedRepresentative.create(form)
        }
    }

    const handleFormSubmit = (event) => {
        try {
            const form = FormUtils.setupSubmitForm(changedForms, {}, true, false, {guid: guid})
            createOrUpdate(form)
                .onSuccess(() => {
                    message.success("数据已保存")
                    navigator(-1)
                })
        } catch (e) {
            message.error(e.message)
            return false
        }
    }

    return (
        <>
            <AutoFormCard
                title={"人员信息编辑"}
                extra={<a href="http://api.map.baidu.com/lbsapi/getpoint/" target="_blank">[拾取坐标系统]</a>}
                formStruct={FORM}
                initValues={initFormData}
                selectOptions={{
                    educationBackgroundId: educationBackgrounds
                }}
                loading={false}
                onClickCancel={e => {
                    navigator(-1)
                }}
                onClickSubmit={handleFormSubmit}
                onFormChange={handleFormChange}
            />
        </>
    )
}

export default NonalignedEditPage